import { StadiumMaterialuEnum } from 'ciselniky-frontend-ts-axios';
import { useClientFetch } from '../context/ClientStatusContext';
import PolozkaCiselnik from '../model/ciselniky/PolozkaCiselnik';
import { ClientStatus } from '../model/ClientStatus';
import Uuid from '../model/Uuid';
import {
  fetchSprievodnyDokumentTypList,
} from '../client/external/ciselniky/sprievodnyDokumentTypListClient';

interface ReturnType {
  polozkyCiselnik: PolozkaCiselnik[];
  polozkyCiselnikStatus: ClientStatus;
}

export default (
  platny: boolean,
  generovany: boolean,
  povinny: boolean,
  stadium: StadiumMaterialuEnum,
  typMaterialuUuid: Uuid,
): ReturnType => {
  const {
    data: polozkyCiselnik,
    status: polozkyCiselnikStatus,
  } = useClientFetch(
    fetchSprievodnyDokumentTypList,
    [platny, generovany, povinny, stadium, typMaterialuUuid],
    [],
  );
  return {
    polozkyCiselnik: polozkyCiselnik || [],
    polozkyCiselnikStatus,
  };
};
